/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Gatti Filtrazioni
 * OpenAPI spec version: v1
 */
import axios from "axios";
import type { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { useQuery } from "@tanstack/react-query";
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey,
} from "@tanstack/react-query";
import type { GatewayDto } from ".././models";

export const getListaGateway = (
  options?: AxiosRequestConfig
): Promise<AxiosResponse<GatewayDto[]>> => {
  return axios.get(`/api/gateway`, options);
};

export const getGetListaGatewayQueryKey = () => [`/api/gateway`] as const;

export const getGetListaGatewayQueryOptions = <
  TData = Awaited<ReturnType<typeof getListaGateway>>,
  TError = AxiosError<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getListaGateway>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}): UseQueryOptions<
  Awaited<ReturnType<typeof getListaGateway>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetListaGatewayQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getListaGateway>>> = ({
    signal,
  }) => getListaGateway({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions };
};

export type GetListaGatewayQueryResult = NonNullable<
  Awaited<ReturnType<typeof getListaGateway>>
>;
export type GetListaGatewayQueryError = AxiosError<unknown>;

export const useGetListaGateway = <
  TData = Awaited<ReturnType<typeof getListaGateway>>,
  TError = AxiosError<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getListaGateway>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetListaGatewayQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const __$$useGetListaGateway = () =>
  //@ts-ignore
  useGetListaGateway(...([] as any[]));
